module.exports = __webpack_public_path__ + "img/m1-screenshot-04.ceb7b743.png";